import React from 'react';
import Navbar from '../lab/Navbar';
import Sidebar from '../lab/Sidebar';
import WalletContent from './WalletContent';
import './css/Wallet.css';

const Wallet = ({ isCollapsed, toggleSidebar }) => {
    return (
        <div className='lab-container'>
            <Navbar />
            <WalletContent />
        </div>
    );
};

export default Wallet;
